const xls = require('json-as-xlsx');

function exportStats(filename, sheetName, headers, srcData, labelsRef) {
    const columns = headers
        .map(col => {
            return {
                label: col.text,
                value: col.value,
            }
        })
        .filter(obj => obj.value !== 'actions')

    const content = srcData.map(obj => {
        const row = {}

        columns.forEach(col => {
            switch (col.value) {
                case 'label': {row[col.value] = labelsRef[obj[col.value]].text; break;}
                case 'tt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'ttn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'tto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'workTime': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'activeTime': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'ptt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'ptn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'pto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'utt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'utn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'uto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'ntt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'ntn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'nto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'ttt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'idleTime': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
                case 'productivityTarget': {row[col.value] = percentDisplayWithoutUnit(obj[col.value]); break;}
                case 'productivityActive': {row[col.value] = percentDisplayWithoutUnit(obj[col.value]); break;}
                case 'productivityWorkTime': {row[col.value] = percentDisplayWithoutUnit(obj[col.value]); break;}
                default: row[col.value] = obj[col.value]
            }
        })

        return row
    })
    let data = [{
        sheet: sheetName,
        columns: columns,
        content: content
    }]
    let settings = {
        fileName: filename,
    }

    xls(data, settings)
}

function arrSplice(array, spliceOperator) {
    for (let i = 0; i < array.length; i++) {
        let res = spliceOperator(array[i]);
        if (typeof res == 'boolean' && res) {
            array.splice(i, 1);
            return arrSplice(array, spliceOperator);
        }
    }
    return array
}

function arrPopulated(array) {
    return Array.isArray(array) && array.length > 0;
}

function blankString(value) {
    return typeof value === "undefined" || value == null || value === '';
}

function getUUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}

function objectifyArr(arr, identifier) {
    return arr.reduce((obj, item) => {
        try {
            obj[item[identifier]] = item
        } catch (e) {
            // eslint-disable-next-line
            console.log(e)
        }
        return obj
    }, {})
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function validateCellNo(number) {
    var re = /(^0\d\d\d\d\d\d\d\d\d$)|(^27\d\d\d\d\d\d\d\d\d$)/;
    return re.test(number);
}

function arrPushMerge(arr, vals, compareKey) {
    vals.forEach(val => {
        let bExists = arr.reduce((exists, obj) => {
            if (!exists) {
                if (blankString(compareKey)) {
                    if (val === obj) {return true}
                } else {
                    if (val[compareKey] === obj[compareKey]) {return true}
                }
            }
            return exists
        }, false);
        if (!bExists) {arr.push(val)}
    });
    return arr;
}

function boolToInt(boolVal) {
    if (boolVal) {
        return 1
    } else {
        return 0
    }
}

function intToBool(intVal) {
    if (intVal == 1) {
        return true
    } else {
        return false
    }
}

const nameSort = (a,b) => a.name > b.name ? 1 : -1


function getInitials(str) {
    try {
        let arrNames = str.split(' ');
        return `${arrNames[0].split('').shift()}${arrNames.pop().split('').shift()}`.toUpperCase();
    } catch(e) {
        return 'XX'
    }
}

const EventEmitter = require('events');
let snackEmitter = new EventEmitter();
function showSnack(message) {
    snackEmitter.emit('showSnack', message)
}

const validationRules = {
    required: value => !!value || 'Required Value',
    notZero: value => value === '0' || value === '' || value == null ? 'Value can not be zero' : true,
    notNull: value => value !== null || 'Required Value',
    min6Characters: value => !!value && value !== null && value.split('').length >= 6 || 'Minimum 6 characters',
    fourteenCharacters: value => value !== null && value.split('').length === 14 || 'Code has to be 14 characters long',
    specialCharacter: value => value !== null && /[^A-Za-z0-9]/.test(value) || 'Minimum 1 special character (eg. !@#$%)',
    upperCase: value => value !== null && /[A-Z]/.test(value) || 'Minimum 1 uppercase character',
    lowerCase: value => value !== null && /[a-z]/.test(value) || 'Minimum 1 lowercase character',
    numeric: value => value !== null && /[0-9]+/.test(value) || 'Minimum 1 numerical character',
    numberOnly: value => value !== null && /^[\d\\.]+$/.test(value) || 'Only numbers allowed',
    wholeNumberOnly: value => value !== null && /^[\d]+$/.test(value) || 'Only whole numbers allowed',
    email: value => {
        if (value && value !== null && value.length > 0) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || 'Invalid Email Address';
        } else {
            return 'Please enter a valid email address'
        }
    },
    cellNo: value => value !== null && /[0-9+ ][^A-Za-z]{9,}/.test(value) || 'Please enter a valid phone number',
    getErrors: (val, ...args) => {
        for (const rule of args) {
            if (rule(val) !== true)
                return rule(val)
        }
        return null
    },
    ipAddress: value => {
        const pattern = /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/;
        return pattern.test((value || '')) || 'Invalid ip address';
    },
    partnerCode: value => {
        if (value && value !== null && value.length > 0) {
            const pattern = /^[0-9][0-9][0-9][0-9][0-9][0-9]$/;
            return pattern.test((value || '')) || 'Invalid partner code';
        } else {
            return 'Please enter a valid partner code'
        }
    },
}

const dateFormats = {
    longDate: 'EEE do MMMM yyyy HH:mmaaa',
    longDateOnly: 'EEE do MMMM yyyy',
    medLongDate: 'do MMMM yyyy HH:mmaaa',
    medDate: 'do MMM h:maaa',
    hourOnly: 'haaa'
}

const copyText = (documentContext, text) => {
    const node = documentContext.createElement("input");
    node.setAttribute('id', 'copyInput')
    node.setAttribute('value', text)
    documentContext.body.appendChild(node);
    const inputBox = documentContext.getElementById('copyInput');
    inputBox.select();
    documentContext.execCommand("copy");
    navigator.clipboard.writeText(inputBox.value)
    documentContext.body.removeChild(node);
}

const durationDisplay = (seconds, dense = false) => {
    let caryOver = seconds;
    const days = Math.floor(seconds / 86400);
    if (days)
        return `${days}${dense ? 'd' : (days > 1 ? ' Days' : ' Day')}`

    const hours = Math.floor(seconds / 3600);
    if (hours)
        return `${hours}${dense ? 'h' : (hours > 1 ? ' Hours' : ' Hour')}`

    const min = Math.floor(seconds / 60);
    if (min)
        return `${min}${dense ? 'm' : (min > 1 ? ' Minutes' : ' Minute')}`

    return `${Math.floor(seconds)}${dense ? 's' : (Math.floor(seconds) > 1 ? ' Seconds' : ' Second')}`
}

const durationDisplayFull = (seconds, dense = false) => {
    let caryOver = seconds;
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor(seconds / 3600);
    const min = Math.floor(seconds / 60);

    if (days)
        return `${days}:${(Math.floor((seconds % 86400) / 3600)).toString().padStart(2, '0')}${dense ? 'd' : (seconds > 86400 ? ' Days' : ' Day')}`
    if (hours)
        return `${hours}:${(Math.floor((seconds % 3600) / 60)).toString().padStart(2, '0')}${dense ? 'h' : (seconds > 3600 ? ' Hours' : ' Hour')}`
    if (min)
        return `${min}:${(Math.floor(seconds % 60)).toString().padStart(2, '0')}${dense ? 'm' : (seconds > 60 ? ' Minutes' : ' Minute')}`

    return `${Math.floor(seconds)}${dense ? 's' : (Math.floor(seconds) > 1 ? ' Seconds' : ' Second')}`
}

const hourDisplay = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const min = Math.floor((seconds % 3600) / 60);
    return `${(hours < 0 ? 0 : hours).toString().padStart(2,'0')}:${(min < 0 ? 0 : min).toString().padStart(2,'0')}h`
}

const hourDisplayWithoutUnit = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const min = Math.floor((seconds % 3600) / 60);
    const hoursStr = (hours < 0 ? 0 : hours).toString().padStart(2,'0')
    const minutesStr = (min < 0 ? 0 : min).toString().padStart(2,'0')
    return `${hoursStr}${hoursStr.split('').length >= 3 ? '' : `:${minutesStr}`}`
}

const minuteDisplayWithoutUnit = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60)
    return `${(min < 0 ? 0 : min).toString().padStart(2,'0')}:${(sec < 0 ? 0 : sec).toString().padStart(2,'0')}`
}

const hourDisplayDecimal = (seconds) => {
    const hours = +((seconds / 3600).toFixed(2));
    return hours
}

const percentDisplay = (val) => {
    try {
        return val.toFixed(1) + '%'
    } catch (e) {
        return '0%'
    }
}

const percentDisplayWithoutUnit = (val) => {
    try {
        return +(val.toFixed(1))
    } catch (e) {
        return 0
    }
}

const isValidUrl = urlString=> {
    try {
        console.log(urlString)
      // let urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
      //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
      //     '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
      //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
      //     '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
      //     '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
      const urlPattern = /^(https?:\/\/)?([a-z\d-]+\.)+[a-z]{2,}(:\d+)?(\/[^\s]*)?$/i;
      return !!urlPattern.test(urlString);
    } catch (e) {
      console.log(e)
        return false;
    }
}

function mergeRecursive(target, src) {
    for (let p in src) {
        try {
            if ( src[p].constructor==Object ) {
                target[p] = mergeRecursive(target[p], src[p]);
            } else {
                target[p] = src[p];
            }
        } catch(e) {
            target[p] = src[p];
        }
    }
    return target;
}

module.exports = {
    arrSplice,
    arrPopulated,
    blankString,
    getUUID,
    objectifyArr,
    validateEmail,
    validateCellNo,
    arrPushMerge,
    intToBool,
    boolToInt,
    showSnack,
    getInitials,
    snackEmitter,
    validationRules,
    dateFormats,
    copyText,
    nameSort,
    durationDisplay,
    percentDisplay,
    hourDisplay,
    hourDisplayWithoutUnit,
    isValidUrl,
    exportStats,
    percentDisplayWithoutUnit,
    minuteDisplayWithoutUnit,
    mergeRecursive,
    durationDisplayFull

}
